$(document).ready(function () {

    if(localStorage.getItem('data-theme') === 'dark'){
        $('body').attr('data-theme', 'dark');
        $(".change-theme").attr("checked",true);
    }

    $('.change-theme').on('change', function () {
        let checked = $(this).is(':checked');
        if (checked) {
            $('body').attr('data-theme', 'dark')
            localStorage.setItem('data-theme', 'dark')
        }
        else {
            $('body').attr('data-theme', 'light')
            localStorage.setItem('data-theme', 'light')
        }
    })
});








